import FormInput from './components/FormInput'
import FormSelect from './components/FormSelect'
import FormTextarea from './components/FormTextarea'
import FormDatepicker from './components/FormDatepicker'
import FormTimepicker from './components/FormTimepicker'
import FormAutocomplete from './components/FormAutocomplete'

export default {
  install(Vue) {
    Vue.component('form-input', FormInput)
    Vue.component('form-select', FormSelect)
    Vue.component('form-textarea', FormTextarea)
    Vue.component('form-datepicker', FormDatepicker)
    Vue.component('form-timepicker', FormTimepicker)
    Vue.component('form-autocomplete', FormAutocomplete)
  }
}